import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
export const COMPLETED_CLASSIFICATIONS = "COMPLETED_CLASSIFICATIONS";
export const OUTSTANDING_CLASSIFICATIONS = "OUTSTANDING_CLASSIFICATIONS";
export const CLASSIFICATIONS_FROM_STATUS = "CLASSIFICATIONS_FROM_STATUS";
const getters = {
  [COMPLETED_CLASSIFICATIONS]: state => applicationId => {
    var _context;
    const classifications = state.classifications.byApplication[applicationId];
    const documents = state.documents.byApplication[applicationId];
    return _filterInstanceProperty(_context = classifications.allIds).call(_context, documentRequestId => {
      const classification = classifications.byId[documentRequestId];
      const allCompleted = classification.documents.every(documentId => documents.byId[documentId].requestStatus === "complete");
      return classification.sent && classification.requestedFromApplicant && classification.documents.length && allCompleted;
    });
  },
  [OUTSTANDING_CLASSIFICATIONS]: state => applicationId => {
    var _context2;
    const classifications = state.classifications.byApplication[applicationId];
    const documents = state.documents.byApplication[applicationId];
    return _filterInstanceProperty(_context2 = classifications.allIds).call(_context2, documentRequestId => {
      const classification = classifications.byId[documentRequestId];
      const someOutstanding = classification.documents.some(documentId => documents.byId[documentId].requestStatus !== "complete");
      return classification.sent && classification.requestedFromApplicant && (classification.documents.length === 0 || someOutstanding);
    });
  }
};
export default getters;